import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type SettingsPageAutoChatReplyKeywordLinkSectionPanelAutoChatReplySettingFragment = { __typename?: 'AutoChatReplySetting', id: string, extra: { __typename?: 'AutoChatReplySettingExtra', type: Types.AutoChatReplySettingExtraType, question?: { __typename?: 'AutoChatReplySettingExtraQuestion', selections: Array<{ __typename?: 'AutoChatReplySettingExtraQuestionSelectionItem', text: string, link?: { __typename?: 'AutoChatReplySetting', id: string } | null }> } | null } };

export const SettingsPageAutoChatReplyKeywordLinkSectionPanelAutoChatReplySettingFragmentDoc = gql`
    fragment SettingsPageAutoChatReplyKeywordLinkSectionPanelAutoChatReplySetting on AutoChatReplySetting {
  id
  extra {
    type
    question {
      selections {
        text
        link {
          id
        }
      }
    }
  }
}
    `;